<template>
  <div class="interativa">
      <CabecalhoInterativo id="navbar" class="entraSuave1" v-if="validacao" />
      <MenuInterativo  id="menuLateralinterativo" class="entraSuave2" v-if="validacao" />
      <ConteudoInterativo class="contentInterativo entraSuave3" v-if="validacao" v-ajusteConteudo="MenuVisivel" />
      <Loading class="loadInterativo" v-else />
  </div> <!--Final da DIV INTERATIVA-->
</template>

<script>
import axios from "axios"
import { baseApiUrl, userKey } from "../../global"
import { mapState } from "vuex"

export default {
    name: 'Interativa',
    components: {
      CabecalhoInterativo: () => import(/* webpackChunkName: "interativa" */ "./CabecalhoInterativo"),
      MenuInterativo: () => import(/* webpackChunkName: "interativa" */ "./MenuInterativo"),
      ConteudoInterativo: () => import(/* webpackChunkName: "interativa" */ "./ConteudoInterativo"),
      Loading: () => import(/* webpackChunkName: "interativa" */ "./Loading"),
    },
    computed: {
      ...mapState(['MenuVisivel', 'usuario']),
      validacao() { return (!this.validatingToken && this.usuario) },
    },
    data: function() {
      return {
        validatingToken: true,
      }
    },
    directives: {
			ajusteConteudo: {
				inserted: function (el, binding) {
            if(window.innerWidth <= 575) el.style.width = "100%";
            else {
              if (binding.value) {
                  el.style.marginLeft = "auto";
                  el.style.marginRight = "0";
                  el.style.width = "calc(100% - 270px)";
              } else {
                  el.style.width = "100%";
              }
            }
        },
				update: function (el, binding) {
          if(window.innerWidth >= 576) {
            if (binding.value) {
                el.style.marginLeft = "auto";
                el.style.marginRight = "0";
                el.style.transition="width 0.75s";
                el.style.width = "calc(100% - 270px)";
            } else {
              setTimeout(function(){
                  el.style.transition="width 0.75s";
                  el.style.width = "100%";
              }, 500);
            }
          }
        }
      }
    },
    methods: {
      async validateToken() {
        this.validatingToken = true

        const json = localStorage.getItem(userKey)
        const userData = JSON.parse(json)
        this.$store.commit('setUser', null)

        if(!userData) {
          this.validatingToken = false
          this.$router.push({ name: 'Auth' })
          return
        }

        const res = await axios.post(`${baseApiUrl}/validaToken`, userData)
        /*const res = 
            {id:1,nome_razao:"Bruno Martin de Alcantara Dias",email:"bruno.dias@hiontecnologia.com.br",cpf_cnpj:"22813823899",hion:true,admin:true,nivel:0,prt:255,apelido:"ALCANTARA DIAS",foto:"avatar_bmad.jpg",preferencia:0,status:"ativo",iat:1594843024,exp:1594846624,token:"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwibm9tZV9yYXphbyI6IkJydW5vIE1hcnRpbiBkZSBBbGNhbnRhcmEgRGlhcyIsImVtYWlsIjoiYnJ1bm8uZGlhc0BoaW9udGVjbm9sb2dpYS5jb20uYnIiLCJjcGZfY25waiI6IjIyODEzODIzODk5IiwiaGlvbiI6dHJ1ZSwiYWRtaW4iOnRydWUsIm5pdmVsIjowLCJwcnQiOjI1NSwiYXBlbGlkbyI6IkFMQ0FOVEFSQSBESUFTIiwiZm90byI6ImF2YXRhcl9ibWFkLmpwZyIsInByZWZlcmVuY2lhIjowLCJzdGF0dXMiOiJhdGl2byIsImlhdCI6MTU5NDg0MzAyNCwiZXhwIjoxNTk0ODQ2NjI0fQ.jWDblEo9t5Nn4ozDyfdgCsDvPxBSaljedMjtfibgvh4"}

        this.$store.commit('setUser', res) */

        if (res.data) {
          this.$store.commit('setUser', userData)
          if(this.$mq === 'xs') {
            this.$store.commit('alternaMenu', false)
          }
        } else {
          localStorage.removeItem(userKey)
          this.$router.push({ name: 'Auth' })
        }

        this.validatingToken = false;
      },
      cab_int_fixo_Scroll() {
        let navbar = document.getElementById("navbar");
          if(navbar) {
            if (window.pageYOffset >= 240) {
              navbar.classList.add("sticky");
            } else {
              navbar.classList.remove("sticky");
            }
          }
      },
      redimensiona() {
        if(this.$mq === 'xs') {
          document.querySelector('.contentInterativo').style.transition="width 1s";
          document.querySelector('.contentInterativo').style.width = "100%";
        }
        if(this.$mq !== 'xs' && this.MenuVisivel) {
          document.querySelector('.contentInterativo').style.transition="width 1s";
          document.querySelector('.contentInterativo').style.marginLeft = "auto";
          document.querySelector('.contentInterativo').style.marginRight = "0";
          document.querySelector('.contentInterativo').style.width = "calc(100% - 270px)";
        }
      }
    },
    created() {
      this.validateToken();
      window.addEventListener('scroll', this.cab_int_fixo_Scroll);
      window.addEventListener('resize', this.redimensiona)
    },
    destroyed () {
      window.removeEventListener('scroll', this.cab_int_fixo_Scroll);
      window.removeEventListener('resize', this.redimensiona)
    },
}

</script>

<style>
.interativa {
    position: relative;
    color: #2e2d2c;
    height: 100%;
    width: 100%;
    min-height: 700px;
    margin: 0;
    z-index: 3;
    overflow-x: visible;
}
.entraSuave1 {
  animation: suavidade1 1.5s linear;
  animation-iteration-count: 1;
}
.entraSuave2 {
  animation: suavidade2 1.5s linear;
  animation-iteration-count: 1;
}
.entraSuave3 {
  animation: suavidade3 1.5s linear;
  animation-iteration-count: 1;
}

@keyframes suavidade1 {
  0%{
    opacity: 0;
  }
  33%{
    opacity: 1;
  }
}
@keyframes suavidade2 {
  0%{
    opacity: 0;
  }
  33%{
    opacity: 0;
  }
  66%{
    opacity: 1;
  }
}
@keyframes suavidade3 {
  0%{
    opacity: 0;
  }
  66%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}

#navbar {
   z-index: 5;
}
#menuLateralinterativo {
  position: absolute;
  height: calc(100% - 50px);
  top: 50px;
  left: 0px;
  z-index: 4;
}

.contentInterativo {
  width: 100%;
}
.loadInterativo{
  width: 100%;
}

.sticky {
  position: fixed !important;
  top: 0;
  width: 100%;
}

</style>